import React from 'react';
import Toolbar from 'src/components/Toolbar';
import { useLocation } from 'react-router-dom';
import qs from 'qs';

const ItemDetail = () => {
  let location = useLocation();
  let queryUrl = location.search;
  const queryParams = qs.parse(queryUrl, { ignoreQueryPrefix: true });
  console.log('Query param', queryParams);

  return (
    <div className="screen-container bg-background">
      <Toolbar title={queryParams.name as string} />
      <div className="max-w-md mx-auto">
        <iframe
          is="x-frame-bypass"
          title={queryParams.name as string}
          src={queryParams.link as string}
          width="100%"
          style={{
            minHeight: '100vh',
          }}
        ></iframe>
      </div>
    </div>
  );
};

export default ItemDetail;
